import { theme } from 'theme'

import { SxProps } from '@mui/material'

const paper: SxProps = {
  p: { xs: 2, sm: 3 },
}

const mainInfo: SxProps = {
  display: 'flex',
  gap: 3,
  borderBottom: '1px solid',
  borderColor: theme.palette.gray.main,
  pb: 2,
}

const avatar: SxProps = {
  width: 80,
  height: 80,

  typography: { color: theme.palette.text.contrast, fontSize: '40px' },
}

const mainInfoContentContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  mt: 1,
}

const mainInfoTitleContainer: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  svg: { cursor: 'pointer' },
}

const Styles = {
  paper,
  avatar,
  mainInfo,
  mainInfoContentContainer,
  mainInfoTitleContainer,
}

export default Styles
